module.exports = __webpack_public_path__ + "assets/img/title-5ed8f1e2.png";